import { render, staticRenderFns } from "./CollectionDataSourceForm.vue?vue&type=template&id=1eb34379&scoped=true&"
import script from "./CollectionDataSourceForm.vue?vue&type=script&lang=js&"
export * from "./CollectionDataSourceForm.vue?vue&type=script&lang=js&"
import style0 from "./CollectionDataSourceForm.vue?vue&type=style&index=0&id=1eb34379&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb34379",
  null
  
)

export default component.exports